/**
 * 수업 예약(폼 3) React Query 훅
 *
 * 백엔드 `createSchedule` (packages/@vlab-corporation/firebase-functions/src/schedule/create-schedule.ts)와
 * 1:1 contract. 센터 상세 페이지에서 모달을 통해 호출한다.
 */

import { useMutation } from "@tanstack/react-query";
import { httpsCallable } from "firebase/functions";
import { getFirebaseFunctions } from "@/config/firebase";

// --- 백엔드 contract ---

/** 예약 회원 1명 (name + mobile = unique key, ticketTitle = 회원 보유 수강권명) */
export interface ScheduleMemberInput {
  name: string;
  mobile: string;
  /** 해당 회원이 보유한 수강권명 (회원별 검증) */
  ticketTitle: string;
}

interface CreateScheduleRequest {
  centerName: string;
  title: string;
  type: "P" | "G";
  maxTrainee: number;
  /** KST "YYYY-MM-DDTHH:mm" */
  startOn: string;
  /** KST "YYYY-MM-DDTHH:mm" */
  endOn: string;
  staffName: string;
  staffMobile?: string;
  members: ScheduleMemberInput[];
}

interface CreateScheduleResponse {
  success: true;
  /** 발급된 scheduleId (10자리 이상) */
  scheduleId: number;
}

export interface CreateScheduleParams {
  centerName: string;
  title: string;
  type: "P" | "G";
  maxTrainee: number;
  startOn: string;
  endOn: string;
  staffName: string;
  staffMobile?: string;
  members: ScheduleMemberInput[];
}

/**
 * 수업 예약 mutation.
 *
 * 성공 시 서버에서 발급된 scheduleId를 반환한다. 본 폼은 목록을 표시하지 않으므로
 * 호출자(모달의 onSuccess)는 모달 close + 성공 배너만 처리한다.
 */
export function useCreateSchedule() {
  return useMutation({
    mutationFn: async (params: CreateScheduleParams) => {
      const fn = httpsCallable<CreateScheduleRequest, CreateScheduleResponse>(
        getFirebaseFunctions(),
        "createSchedule",
      );
      const result = await fn(params);
      return result.data;
    },
  });
}
